/**
 * PacingSlider — Compliment_Pacing_Policy intensity selector.
 *
 * Animasyonlar her zaman açık — hareket ayarı kaldırıldı.
 */

import type { ChangeEvent, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import type { PacingIntensity } from '../../domain/types';
import { usePreferencesStore } from '../../state';

import styles from './PacingSlider.module.css';

const PACING_OPTIONS: readonly PacingIntensity[] = [
  'subtle',
  'balanced',
  'warm',
] as const;

export function PacingSlider(): ReactElement {
  const { t } = useTranslation();
  const prefs = usePreferencesStore((s) => s.preferences);
  const setPacing = usePreferencesStore((s) => s.setPacing);

  const onPacingChange =
    (value: PacingIntensity) =>
    (e: ChangeEvent<HTMLInputElement>): void => {
      if (e.target.checked) void setPacing(value);
    };

  return (
    <section
      className={styles.section}
      aria-labelledby="pacing-heading"
      data-testid="pacing-slider"
    >
      <h2 id="pacing-heading" className={styles.heading}>
        {t('settings.pacing.title')}
      </h2>
      <fieldset
        className={styles.chipGroup}
        aria-labelledby="pacing-heading"
      >
        {PACING_OPTIONS.map((p) => {
          const active = prefs.pacing === p;
          return (
            <label
              key={p}
              className={[styles.pacingChip, active ? styles.pacingChipActive : '']
                .filter((c): c is string => typeof c === 'string' && c.length > 0)
                .join(' ')}
            >
              <input
                type="radio"
                name="pacing"
                value={p}
                checked={active}
                onChange={onPacingChange(p)}
                className={styles.srOnly}
              />
              <span>{t(`settings.pacing.${p}`)}</span>
            </label>
          );
        })}
      </fieldset>
    </section>
  );
}
